import React, { useContext } from 'react';
import { Outlet } from 'react-router-dom';
import { LoginContext } from './common/App';
import { NavigateSmart } from './common/Common';
import { ConsumerContext } from '.';
import { MediationStatus } from './common/enums.mjs';
import { compareMediationStatus } from './common/util';


export const ApplicationInterestingRoute = () => {
    const consumer = useContext(ConsumerContext);
    const login = useContext(LoginContext);


    return (
        !login.loggedIn ?
            null
        :
            compareMediationStatus(consumer.mediationStatus, MediationStatus.APPLICATION_INTERESTING) ?
                <Outlet />
            :
                <NavigateSmart to="/be_patient/"/>
    );
};

export default ApplicationInterestingRoute
